<template>
  <div>
    <div :style="getSectionStyle()">
      <span class="image-overlay"></span>
      <HomeMainSection />
    </div>
    <div id="services">
      <Services />
    </div>
    <div id="products">
      <div class="products-container">
        <ProductHeader />
        <ProductCard
          :products="listOfProducts.slice(0, 3)"
          :showAllProductLink="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Services from "../services/Services";
import ProductHeader from "../products/ProductHeader";
import ProductCard from "../products/ProductCard";
import HomeMainSection from "./HomeMainSection";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    HomeMainSection,
    Services,
    ProductHeader,
    ProductCard
  },
  computed: mapGetters(["listOfProducts"]),
  methods: {
    getImage(name) {
      return require("../../assets/" + name);
    },
    getSectionStyle() {
      let obj = {
        "background-image": `url(${this.getImage("mainbg.jpg")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-attachment": "fixed",
        "-o-background-size": "cover",
        "-moz-background-size": "cover",
        "-webkit-background-size": "cover",
        "background-size": "cover"
      };

      if (this.isMobileSafari()) obj["background-attachment"] = "scroll";

      return obj;
    },
    isMobileSafari() {
      return (
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.products-container {
  padding-top: 200px;
}

@media (max-width: 768px) {
  .products-container {
    padding-top: 100px;
  }
}
</style>
